var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgLogoNoMargin = function SvgLogoNoMargin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#4184F4",
    d: "M12.38.03A12.07 12.07 0 0 0 1.58 13.4a12.17 12.17 0 0 0 2.56 6.11 12.01 12.01 0 0 0 8.09 4.44 11.82 11.82 0 0 0 5.22-.6 12.44 12.44 0 0 0 4.76-3.06l.1-.13-.13-.13-1.25-1.16-1.12-1.03-.3.28a8.6 8.6 0 0 1-9.4 1.75 8.62 8.62 0 0 1-5.15-8.15A8.55 8.55 0 0 1 19.5 5.88l.4.38 2.52-2.27s.01-.04-.46-.52A11.87 11.87 0 0 0 12.38.03Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#4184F4",
    d: "m15.44 10.7-1.92 1.94c-.02 0-.86-.81-1.87-1.82L9.82 9l-1.2 1.22-1.2 1.23 3.05 3.05c1.67 1.67 3.05 3.04 3.06 3.03a710.24 710.24 0 0 0 5.79-5.87l.46-.46-1.05-1.06a48.31 48.31 0 0 0-1.23-1.2l-.17-.15-1.89 1.92Z"
  })));
};
export default SvgLogoNoMargin;